/* eslint-disable @typescript-eslint/no-unused-vars */
import { useContext, useEffect, useRef, useState } from 'react'

import { callApiWithOptionalAuth } from 'api/utils'
import { useRouter } from 'next/router'

import { initialState, TogetherDataContext } from '../'
import { formatPost, formatPostPagination } from '../api/dataTransform'
import { PATHS } from '../api/paths'
// import { PostPaginationClient } from '../api/types'
import { getTogetherPath } from '../api/utils'
import { Post } from '../interfaces/types'
import { PostActions } from '../state/postReducer'

export enum LoadMoreEnum {
  idle = 1,
  loading = 3,
}

export type Props = {
  // requestParams?: { [k: string]: string }
  // requestParams?: any
  // posts: Post[]
  // postPagination?: PostPaginationClient | null
}
export const useInfinityScrollPost = ({
  requestParams,
  posts: postsProps,
  postPagination: postPaginationProps,
}: any) => {
  const { locale = 'vi-VN' } = useRouter()
  const [posts, setPosts] = useState(postsProps || [])
  const [showLoading, setShowLoading] = useState(false)
  const [postPagination, setPostPagination] = useState(postPaginationProps)
  const loadMoreRef = useRef<LoadMoreEnum>(LoadMoreEnum.idle)
  const firstSort = useRef(true)
  const postContainerRef = useRef<HTMLDivElement>(null)
  const noMoreDataRef = useRef<boolean>(false)
  const { state = initialState, dispatch } =
    useContext(TogetherDataContext) || {}
  const { postsById } = state
  useEffect(() => {
    setPosts(postsProps || [])
    dispatch({
      type: PostActions.updateMultiple,
      payload: {
        dataArr: postsProps,
      },
    })
  }, [postsProps])
  const onScroll = async () => {
    if (postContainerRef.current) {
      const { bottom } = postContainerRef.current.getBoundingClientRect()
      const shouldLoadMore = bottom < (3 / 2) * window.innerHeight
      if (
        shouldLoadMore &&
        loadMoreRef.current === LoadMoreEnum.idle &&
        postPagination &&
        postPagination.currentPage < postPagination.lastPage &&
        !noMoreDataRef.current
      ) {
        loadMoreRef.current = LoadMoreEnum.loading
        setShowLoading(true)
        // LOAD MORE
        try {
          const nextPostsApiRes = await callApiWithOptionalAuth(
            getTogetherPath(PATHS.POST.LIST || '', {
              _locale: locale,
              page: Number(postPagination?.currentPage || '1') + 1,
              ...(requestParams || {}),
            }),
            'GET',
          )
          const apiRes = nextPostsApiRes?.data || {}
          const nextPosts: Post[] = apiRes?.posts?.map(formatPost) || []
          if (nextPosts.length === 0) {
            noMoreDataRef.current = true
          }
          dispatch({
            type: PostActions.updateMultiple,
            payload: {
              dataArr: nextPosts,
            },
          })
          setPosts((_posts: any) =>
            _posts
              ?.filter((_p: any) => !nextPosts.find((np) => np.id === _p.id))
              .concat(nextPosts),
          )
          setPostPagination(
            apiRes?.pagination
              ? formatPostPagination(apiRes.pagination) || null
              : null,
          )
        } catch (e) {
          console.error(e)
        }
        setTimeout(() => {
          loadMoreRef.current = LoadMoreEnum.idle
          setShowLoading(false)
        }, 300)
      }
    }
  }
  const onScrollRef = useRef<() => void>()
  onScrollRef.current = onScroll

  useEffect(() => {
    // dispatch({
    //   type: PostActions.updateMultiple,
    //   payload: {
    //     dataArr: postsProps,
    //   },
    // })
    const onScrollHandler = () => onScrollRef.current?.()

    document.addEventListener('scroll', onScrollHandler)
    return () => document.removeEventListener('scroll', onScrollHandler)
  }, [])

  const handleCreateEditPost = (post: Post) => {
    setPosts((_posts: any) => {
      const foundIndex = _posts.findIndex((p: any) => p.id == post.id)

      if (foundIndex > -1) {
        _posts[foundIndex] = post
      } else {
        _posts.unshift(post)
      }
      return _posts.slice()
    })
  }
  const handleDeletePost = (postId: string) => {
    setPosts((_posts: any) => {
      const foundIndex = _posts.findIndex((p: any) => p.id == postId)
      if (foundIndex > -1) {
        _posts.splice(foundIndex, 1)
      }
      return _posts.slice()
    })
  }
  const refetch = async () => {
    loadMoreRef.current = LoadMoreEnum.loading
    setPosts([])
    setShowLoading(true)
    // LOAD MORE
    try {
      const postsApiRes = await callApiWithOptionalAuth(
        getTogetherPath(PATHS.POST.LIST, {
          _locale: locale,
          page: '1',
          ...(requestParams || {}),
        }),
        'GET',
      )
      const apiRes = postsApiRes?.data || {}
      const resPosts: Post[] = apiRes?.posts?.map(formatPost) || []
      if (resPosts.length === 0) {
        noMoreDataRef.current = true
      } else {
        noMoreDataRef.current = false
      }
      dispatch({
        type: PostActions.updateMultiple,
        payload: {
          dataArr: resPosts,
        },
      })
      setPosts(resPosts)
      setPostPagination(
        apiRes?.pagination
          ? formatPostPagination(apiRes.pagination) || null
          : null,
      )
    } catch (e) {
      console.error(e)
    }
    setTimeout(() => {
      loadMoreRef.current = LoadMoreEnum.idle
      setShowLoading(false)
    }, 300)
  }
  const currentSort = requestParams?.sort
  useEffect(() => {
    if (firstSort.current) {
      firstSort.current = false
    } else {
      refetch()
    }
  }, [currentSort])

  useEffect(() => {
    dispatch({
      type: PostActions.updateMultiple,
      payload: {
        dataArr: posts,
      },
    })
  }, [posts])

  const returnPosts = posts.map((p: any) => (p.id && postsById[p.id]) || p)
  return {
    posts: returnPosts,
    setPosts,
    loading: showLoading,
    postContainerRef,
    handleCreateEditPost,
    refetch,
    handleDeletePost,
  }
}
